import apiFetch from '../apiFetch'

export default function () {
  return apiFetch({endPoint: `combos/getComboPool`, method: 'GET'})
}
